module.exports = __webpack_public_path__ + "img/39953dd.jpg";